import * as React from 'react';
import type { CircularProgressProps } from '@mui/material/CircularProgress';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import type { JSX } from 'react';

export function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number }
): JSX.Element {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
          }}
          component="div"
          color="primary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
